import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

const Print = (props) => {
  const {
    children,
    groupName,
    type = '',
    triggerDownload,
    onDownloadComplete,
    disabled = true,
    orientation = 'p',
  } = props;
  const printRef = useRef();

  const handleDownload = async () => {
    const element = printRef.current;

    const canvas = await html2canvas(element, {
      scale: 2, // Increase scale for better resolution
      useCORS: true,
      scrollX: 0,
      scrollY: -window.scrollY, // Adjust scroll position
      backgroundColor: '#FFFFFF', // Set background color to white
    });
    const imgData = canvas.toDataURL('image/jpeg', 1);

    const pdf = new jsPDF({
      orientation,
      unit: 'mm',
      format: 'a4',
    });

    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();
    const imgWidth = pdfWidth;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    let heightLeft = imgHeight;
    let position = 0;

    while (heightLeft > 0) {
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pdfHeight;
      position -= pdfHeight;
      if (heightLeft > 0) pdf.addPage();
    }

    pdf.save(`${groupName}-${type}.pdf`);
    onDownloadComplete();
  };

  useEffect(() => {
    if (!disabled && triggerDownload) {
      handleDownload();
    }
  }, [triggerDownload]);

  return (
    <div
      ref={printRef}
      style={{
        position: 'absolute',
        top: '-9999px',
        left: '-9999px',
        fontSize: '40px',
      }}
    >
      {children}
    </div>
  );
};

Print.propTypes = {
  children: PropTypes.node.isRequired,
  groupName: PropTypes.string.isRequired,
  type: PropTypes.string,
  triggerDownload: PropTypes.bool.isRequired,
  onDownloadComplete: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  orientation: PropTypes.string,
};

export default Print;
